import React, { useState } from 'react';
import { X, Loader2 } from 'lucide-react';

const OPTIONS = [
  { value: 'Bug',         label: 'Bug',  cls: 'bg-red-500 text-white hover:bg-red-600' },
  { value: 'Test',        label: 'Test', cls: 'bg-amber-500 text-white hover:bg-amber-600' },
  { value: 'Environment', label: 'Env',  cls: 'bg-blue-500 text-white hover:bg-blue-600' },
];

export default function BatchRootCauseBar({ count, onApply, onClear, onLinkBug, linkBugStatus }) {
  const [bugId, setBugId] = useState('');
  const [linking, setLinking] = useState(false);

  if (!count) return null;

  const submitLinkBug = async () => {
    const id = bugId.trim().replace(/^#/, '');
    if (!id || !onLinkBug) return;
    setLinking(true);
    try {
      await onLinkBug(id);
      setBugId('');
    } finally {
      setLinking(false);
    }
  };

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-50 flex flex-col items-center gap-2">
      {linkBugStatus && (
        <div className={`text-xs px-3 py-1.5 rounded-lg shadow ${linkBugStatus.type === 'error' ? 'bg-red-50 text-red-700 border border-red-200' : 'bg-green-50 text-green-700 border border-green-200'}`}>
          {linkBugStatus.message}
        </div>
      )}
      <div className="flex items-center gap-3 bg-white border border-gray-200 rounded-2xl shadow-xl px-5 py-3">
        <span className="text-sm font-semibold text-gray-800">
          {count} test{count > 1 ? 's' : ''} sélectionné{count > 1 ? 's' : ''}
        </span>
        <span className="w-px h-5 bg-gray-200" />
        <span className="text-xs text-gray-500">Root cause :</span>
        {OPTIONS.map(opt => (
          <button
            key={opt.value}
            onClick={() => onApply(opt.value)}
            className={`px-3 py-1.5 text-sm rounded-lg font-medium transition-colors ${opt.cls}`}
          >
            {opt.label}
          </button>
        ))}
        <button
          onClick={() => onApply(null)}
          className="px-3 py-1.5 text-sm rounded-lg font-medium bg-gray-100 text-gray-600 hover:bg-gray-200 transition-colors"
        >
          Effacer
        </button>
        {onLinkBug && (
          <>
            <span className="w-px h-5 bg-gray-200" />
            <span className="text-xs text-gray-500" title="Numéro du work item ADO (ex: 72954) — pas d'URL, le # est optionnel">Lier au bug :</span>
            <input
              type="text"
              value={bugId}
              onChange={e => setBugId(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter') submitLinkBug(); }}
              placeholder="N° bug"
              title="Numéro du work item ADO (ex: 72954) — pas d'URL, le # est optionnel"
              disabled={linking}
              className="w-20 text-sm border border-gray-300 rounded-lg px-2 py-1 focus:outline-none focus:border-blue-400"
            />
            <button
              onClick={submitLinkBug}
              disabled={linking || !bugId.trim()}
              className="px-3 py-1.5 text-sm rounded-lg font-medium bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-50 flex items-center gap-1"
            >
              {linking && <Loader2 className="w-3 h-3 animate-spin" />}
              Lier tout
            </button>
          </>
        )}
        <span className="w-px h-5 bg-gray-200" />
        <button onClick={onClear} className="p-1 text-gray-400 hover:text-gray-600 rounded-full hover:bg-gray-100 transition-colors" title="Désélectionner tout">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
